import { Spin } from '@components/Loading'
import styled from 'styled-components'

export const StyledSpinner = styled(Spin)`
  margin: auto;
  background-color: ${({ theme }) => theme.colors.primaryLight};
`
